import * as XLSX from 'xlsx';

/**
 * Generates and downloads a real .xlsx file, one row per record.
 * Keys of the first object become the column headers.
 */
export function exportXlsx(filename: string, sheetName: string, rows: Record<string, any>[]): void {
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31));
  XLSX.writeFile(workbook, filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`);
}
